(function() {
    'use strict';

    angular
        .module('telestatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('virtual-number', {
            /*
            parent: 'entity',
            */
            parent: 'dictionary',
            url: '/virtual-number?page&sort&search',
            data: {
                /*
                authorities: ['ROLE_USER'],
                */
                authorities: ['ROLE_ADMIN', 'ROLE_MANAGER', 'ROLE_DIRECTOR'],
                pageTitle: 'telestatApp.virtualNumber.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/virtual-number/virtual-numbers.html',
                    controller: 'VirtualNumberController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('virtualNumber');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('virtual-number-detail', {
            parent: 'virtual-number',
            url: '/virtual-number/{id}',
            data: {
                /*
                authorities: ['ROLE_USER'],
                */
                authorities: ['ROLE_ADMIN', 'ROLE_MANAGER', 'ROLE_DIRECTOR'],
                pageTitle: 'telestatApp.virtualNumber.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/virtual-number/virtual-number-detail.html',
                    controller: 'VirtualNumberDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('virtualNumber');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'VirtualNumber', function($stateParams, VirtualNumber) {
                    return VirtualNumber.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'virtual-number',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('virtual-number-detail.edit', {
            parent: 'virtual-number-detail',
            url: '/detail/edit',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN', 'ROLE_DIRECTOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/virtual-number/virtual-number-dialog.html',
                    controller: 'VirtualNumberDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['VirtualNumber', function(VirtualNumber) {
                            return VirtualNumber.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('virtual-number.new', {
            parent: 'virtual-number',
            url: '/new',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN', 'ROLE_DIRECTOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/virtual-number/virtual-number-dialog.html',
                    controller: 'VirtualNumberDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                locked: false,
                                number: null,
                                source: null,
                                lastActionTime: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('virtual-number', null, { reload: 'virtual-number' });
                }, function() {
                    $state.go('virtual-number');
                });
            }]
        })
        .state('virtual-number.edit', {
            parent: 'virtual-number',
            url: '/{id}/edit',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN', 'ROLE_DIRECTOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/virtual-number/virtual-number-dialog.html',
                    controller: 'VirtualNumberDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['VirtualNumber', function(VirtualNumber) {
                            return VirtualNumber.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('virtual-number', null, { reload: 'virtual-number' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('virtual-number.delete', {
            parent: 'virtual-number',
            url: '/{id}/delete',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN', 'ROLE_DIRECTOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/virtual-number/virtual-number-delete-dialog.html',
                    controller: 'VirtualNumberDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['VirtualNumber', function(VirtualNumber) {
                            return VirtualNumber.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('virtual-number', null, { reload: 'virtual-number' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
